import React, { useEffect } from 'react';
import { LogoYamahaBlack } from '@yme/assets/icons';
import { BTN_DARK_THEME, Button, CONTAINED_VARIANT, NO_ICON, SIZE_44 } from '@yme/atoms/button';
import { SVG } from '@yme/atoms/svg-icon';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
import { HeadingLevel1, HeadingLevel4, RegularTextLevel3 } from '@yme/tokens/typography';
import { onOpenWindow } from '@yme/utils/common';
import { ERROR500_LOGO_TEST_ID, SVG_SIZES } from './constants';
import { getError500Labels } from './helpers';
import { BackgroundStyled, ContentDescriptionStyled, ContentHeaderStyled, ContentStyled, HeaderStyled, LogoStyled, WrapperStyled, } from './styled';
export function Error500({ homeLink, labels, locale, title, isRightToLeft, }) {
    const redirectToHome = () => {
        onOpenWindow(homeLink);
    };
    const error500Labels = getError500Labels(labels);
    useEffect(() => {
        document.title = title;
        document.documentElement.setAttribute('lang', locale);
    }, [locale, title]);
    return (React.createElement(WrapperStyled, { isRightToLeft: isRightToLeft },
        React.createElement(BackgroundStyled, null),
        React.createElement(HeaderStyled, null,
            React.createElement(LogoStyled, null,
                React.createElement("a", { href: homeLink, title: error500Labels.error500LogoTitle, "data-testid": ERROR500_LOGO_TEST_ID },
                    React.createElement(SVG, { width: SVG_SIZES.width, height: SVG_SIZES.height, src: LogoYamahaBlack })))),
        React.createElement("main", null,
            React.createElement(ContentStyled, { isRightToLeft: isRightToLeft },
                React.createElement(ContentHeaderStyled, null,
                    React.createElement(FlexWrapper, { mb: INDENT.xxxxs },
                        React.createElement(HeadingLevel4, { color: colorCoreWhite1000 }, error500Labels.error500SubtitleText)),
                    React.createElement(FlexWrapper, { mb: INDENT.xs },
                        React.createElement(HeadingLevel1, { color: colorCoreWhite1000 }, error500Labels.error500TitleText))),
                React.createElement(ContentDescriptionStyled, null,
                    React.createElement(FlexWrapper, { mb: INDENT.sm },
                        React.createElement(RegularTextLevel3, { color: colorCoreWhite1000 }, error500Labels.error500DescriptionText)),
                    React.createElement(Button, { width: "auto", buttonVariant: CONTAINED_VARIANT, hasIconButton: NO_ICON, size: SIZE_44, onClick: redirectToHome, label: error500Labels.error500ButtonText, isRightToLeft: isRightToLeft, colorSchema: BTN_DARK_THEME }))))));
}
